import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { fetchSystemHistory } from "../../../../api/customer/system";

export function SystemHistory({ systemId }) {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setError(false);
    setData(null);
    fetchSystemHistory(systemId).then((response) => { if (active) setData(response.data); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [systemId, attempt]);
  return <details className="rounded-xl border p-4">
    <summary className="cursor-pointer font-medium">{t("customer.systems.connections_history")}</summary>
    {error ? <p role="alert">{t("customer.systems.load_failed")} <button type="button" onClick={() => setAttempt((value) => value + 1)}>{t("common.retry")}</button></p> : !data ? <p>{t("Loading...")}</p> : <div className="mt-3 space-y-4 text-sm">
      <ul className="space-y-2">{data.reports.map((report) => <li key={report.id}><Link className="text-blue-700 underline" to={`/dashboard/service/reports/${report.id}`}>{report.title}</Link></li>)}</ul>
      <ul className="space-y-2">{data.agreements.map((agreement) => <li key={agreement.id}><Link className="text-blue-700 underline" to={`/dashboard/service/agreements/${agreement.id}`}>{agreement.title}</Link></li>)}</ul>
      <ol className="space-y-2">{data.history.map((event) => <li className="border-t pt-2" key={event.id}>
        <span>{new Date(event.at).toLocaleString()} · {t(`customer.systems.history_action.${event.action}`)}</span>
        {event.data?.changes?.serial_number && <p>{t("Serial Number")}: {event.data.changes.serial_number.map((value) => value || "—").join(" → ")}</p>}
        {event.data?.changes?.system_m_name && <p>{t("Model name")}: {event.data.changes.system_m_name.map((value) => value || "—").join(" → ")}</p>}
        {event.data?.changes?.customer_id && <p>{t("customer.systems.linked_customer")}: {event.data.changes.customer_id.map((value) => value ? `#${value}` : t("customer.systems.no_customer")).join(" → ")}</p>}
      </li>)}</ol>
      <p className="text-xs text-slate-500">{t("customer.systems.history_limit")}</p>
    </div>}
  </details>;
}
